

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface MedicineCategoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface MedicineCategory {
    id?: number;
    code:string;
    name: string;
    
  parameters?: MedicineCategoryParameter[];
  links?: any;
}

export abstract class MedicineCategoryData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<MedicineCategory[]>;
  abstract create(url: string,data: MedicineCategory): Observable<any>;
  abstract update(url: string,data: MedicineCategory): Observable<any>;
  abstract delete(url: string): Observable<any>;

  //uploadfromexcel  
  abstract postData(url: string,data: any[]): Observable<any>;
}